import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import Swal from 'sweetalert2';
import { HttpHelpService } from '../service/http-help.service';

/**
 * Monthly expense quota APIs were removed. This screen uses invoice v2
 * PUT .../subscriptions/:merchantId/adjust with extra_tokens.
 */
@Component({
  selector: 'app-admin-expense-quota',
  templateUrl: './admin-expense-quota.component.html',
  styleUrls: ['./admin-expense-quota.component.scss'],
})
export class AdminExpenseQuotaComponent implements OnInit {
  curentLang = localStorage.getItem('curentLang') || 'ar';

  merchantOptions: { id: number; name: string }[] = [];
  subscriptionPreview: any = null;
  loadingPreview = false;

  adjustForm = new FormGroup({
    merchant_id: new FormControl<number | null>(null, [Validators.required, Validators.min(1)]),
    extra_tokens: new FormControl<number>(0, [Validators.required, Validators.min(1)]),
  });

  constructor(
    private service: HttpHelpService,
    private spinner: NgxSpinnerService,
  ) {}

  ngOnInit(): void {
    this.loadMerchants();
  }

  t(ar: string, en: string, he: string): string {
    if (this.curentLang === 'ar') return ar;
    if (this.curentLang === 'he') return he;
    return en;
  }

  loadMerchants(): void {
    this.service.getAllMerchantInfo().subscribe({
      next: (list: any[]) => {
        const lang = this.curentLang;
        this.merchantOptions = (list || []).map((m) => {
          const name =
            (lang === 'ar' && m.merchant_name_ar) ||
            (lang === 'he' && m.merchant_name_he) ||
            m.merchant_name_en ||
            m.merchant_name_ar ||
            m.merchant_name_he ||
            `#${m.merchant_id}`;
          return { id: m.merchant_id, name };
        }).sort((a, b) => a.name.localeCompare(b.name, undefined, { sensitivity: 'base' }));
      },
      error: () => (this.merchantOptions = []),
    });
  }

  onMerchantChange(): void {
    const id = this.adjustForm.get('merchant_id')?.value;
    this.subscriptionPreview = null;
    if (!id) return;
    this.loadingPreview = true;
    this.service.getAdminMerchantSubscriptionStatus(id).subscribe({
      next: (res) => {
        this.subscriptionPreview = res;
        this.loadingPreview = false;
      },
      error: () => {
        this.subscriptionPreview = null;
        this.loadingPreview = false;
      },
    });
  }

  submitAdjust(): void {
    if (this.adjustForm.invalid) {
      this.adjustForm.markAllAsTouched();
      return;
    }
    const merchantId = Number(this.adjustForm.value.merchant_id);
    const extra_tokens = Number(this.adjustForm.value.extra_tokens);
    this.spinner.show();
    this.service.adjustAdminMerchantSubscription(merchantId, { extra_tokens }).subscribe({
      next: (res) => {
        this.spinner.hide();
        Swal.fire({
          icon: 'success',
          title: this.t('تم التحديث', 'Updated', 'עודכן'),
          text: res?.message || res?.messageEn || '',
        });
        this.onMerchantChange();
      },
      error: (err) => {
        this.spinner.hide();
        const msg = err?.error?.message || err?.error?.messageEn || this.t('فشل الطلب', 'Request failed', 'הבקשה נכשלה');
        Swal.fire({ icon: 'error', title: msg });
      },
    });
  }
}
